/* HauntMask — ajout au panier sans quitter la page (upsell duo du panier + offre duo). */
import { CartLinesUpdateEvent } from '@shopify/events';

function cartSectionIds() {
  const ids = [];
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) ids.push(el.dataset.sectionId);
  });
  return ids;
}

/**
 * Ajoute des articles au panier puis rafraichit le tiroir panier (ouverture automatique).
 * @param {Array<{id: number, quantity: number}>} items
 * @param {EventTarget} [source]
 */
export async function hmAddToCart(items, source) {
  const deferred = CartLinesUpdateEvent.createPromise();
  (source || document).dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: cartSectionIds().join(','), sections_url: window.location.pathname }),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Ajout impossible');

    const cartResponse = await fetch(`${Theme.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    const cart = await cartResponse.json();

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'hm-add-to-cart',
        itemCount: items.reduce((sum, item) => sum + item.quantity, 0),
        sections: data.sections,
        didError: false,
      },
    });
    return cart;
  } catch (error) {
    deferred.reject(error);
    throw error;
  }
}

window.hmAddToCart = hmAddToCart;

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const button = target ? target.closest('[data-hm-quick-add]') : null;
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;
  event.preventDefault();

  const label = button.querySelector('[data-hm-label]') || button;
  const original = label.textContent;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  label.textContent = 'Ajout…';

  hmAddToCart([{ id: Number(button.dataset.variantId), quantity: 1 }], button).catch(() => {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    label.textContent = original;
  });
});